import { EXPORT_DISK_PLACEHOLDER_ERROR, StateMapDisk, WORKSPACE_DISK_PLACEHOLDER_ERROR } from '../state/state_map_disk.enum'
import { backendAxios } from '../../../axios'
import { StateRowTransportValue } from '../../../backend.d'
import type { State } from '../state/State.type'
import { encodePersistedStateBytes } from '../state/persisted_state'
import { getStateDiskByType } from './stateDiskResolver'

export async function saveToDisk(state: State, diskType: StateMapDisk): Promise<StateRowTransportValue> {
  if (diskType === StateMapDisk.Export) {
    throw new Error(EXPORT_DISK_PLACEHOLDER_ERROR)
  }
  if (diskType === StateMapDisk.Workspace) {
    throw new Error(WORKSPACE_DISK_PLACEHOLDER_ERROR)
  }
  if (diskType === StateMapDisk.Cloud) {
    const endpoint = state.type === 1 ? '/st1/map' : state.type === 2 ? '/st1/game' : state.type === 3 ? '/st1/lobby' : '/st1/replay'
    const id = state.map.id
    const body = { data: encodePersistedStateBytes(state) }
    const response = id
        ? await backendAxios.post(`${endpoint}/${id}`, body)
        : await backendAxios.post(endpoint, { state: body.data })
    return response.data
  }

  return await getStateDiskByType(diskType, state.type).save(state)
}
